import store from "@src/reducers/store";
import { transformNodesTreeToFlatArray } from "@src/cloud-connect/utils/transform-nodes-tree-to-flat-array";

/*
 * Intermediate
 *
 * const flatListProvider = FlatListProvider.getInstance();
 * flatListProvider.getFlatInitialStructureList();
 * flatListProvider.getFlatMachineStructureList();
 */
export class FlatListProvider {
  private static instance: FlatListProvider;
  private flatInitialStructureList: any[];
  private flatMachineStructureList: any[];
  private rootNodeNullObject: any;

  private constructor() {
    this.flatInitialStructureList = undefined;
    this.flatMachineStructureList = undefined;
    this.rootNodeNullObject = { children: [] };
  }

  public static getInstance(): FlatListProvider {
    if (!FlatListProvider.instance) {
      FlatListProvider.instance = new FlatListProvider();
    }

    return FlatListProvider.instance;
  }

  private getInitalData(): any {
    const initialData = store.getState().yourSlice.editStructurePageInitialData;
    const rootNode = initialData
      ? initialData.nodeset.root_node
      : this.rootNodeNullObject;

    return rootNode;
  }

  private loadFlatInitialStructureList(): any[] {
    const rootNode = this.getInitalData();
    this.flatInitialStructureList = transformNodesTreeToFlatArray(rootNode);
    return this.flatInitialStructureList;
  }

  public getFlatInitialStructureList(): any[] {
    if (!this.flatInitialStructureList) {
      this.flatInitialStructureList = this.loadFlatInitialStructureList();
    }

    return this.flatInitialStructureList;
  }

  private getTransferData(): any {
    const transferData =
      store.getState().yourSlice.editStructurePageTransferData;
    const rootNode = transferData
      ? transferData.nodeset.root_node
      : this.rootNodeNullObject;

    return rootNode;
  }

  private loadFlatMachineStructureList(): any[] {
    const rootNode = this.getTransferData();
    this.flatMachineStructureList = transformNodesTreeToFlatArray(rootNode);
    return this.flatMachineStructureList;
  }

  // TODO: this could return an older list state that was not changed by the user
  public getFlatMachineStructureList(): any[] {
    if (!this.flatMachineStructureList) {
      this.flatMachineStructureList = this.loadFlatMachineStructureList();
    }

    return this.flatMachineStructureList;
  }

  public deleteFlatInitialStructureList() {
    this.flatInitialStructureList = undefined;
  }

  public deleteFlatMachineStructureList() {
    this.flatMachineStructureList = undefined;
  }
}
